import "./Nitido.scss";

// import { useNavigate } from "react-router-dom";

const Nitido = () => {
  // const navigate = useNavigate();

  return (
    <div className="nitido">
      <div>
        <img src="/images/nitido.png" alt="nitido-logo" />
      </div>
      <div>
        <p className="title">
          Nitido est une marque dédiée à fournir aux professionnels du secteur
          de l'hygiène des produits de haute qualité, réguliers et respectueux
          de l'environnement.
        </p>
        <p className="description">
          Nous nous engageons à offrir des solutions éco-responsables qui
          répondent aux besoins spécifiques de nos clients, tout en garantissant
          un excellent rapport qualité-prix. Chez Nitido, la durabilité et
          l'efficacité vont de pair pour assurer la satisfaction de nos
          partenaires professionnels.
        </p>
        <button
        // onClick={() => navigate("/category-product")}
        >
          Découvrir les produits
        </button>
      </div>
      <div>
        <img src="/images/ProduitsNitido.png" alt="product-nitido" />
      </div>
    </div>
  );
};

export default Nitido;
